import { CctvCameraGridDataModel, GridDataModel, GridWallModel } from 'api/models';
import GridwallCard from '../GridwallCard/GridwallCard';
import { ProjectAssetEnum } from 'api/enums';
import GridWallLiveCameraCard from '../GridwallLiveCameraCard/GridwallLiveCameraCard';

interface IGridwallDetailProps {
    grid: GridWallModel;
    isLoading?: boolean;
}

const GridwallGrid = (props: IGridwallDetailProps) => {
    const { grid, isLoading } = props;

    const renderGridItem = (item: GridDataModel | CctvCameraGridDataModel) => {
        if (item.type === ProjectAssetEnum.CAMERA_CCTV) {
            return (
                <GridWallLiveCameraCard grid={item} options={grid.options} access={grid.access} isLoading={isLoading} />
            );
        }

        return <GridwallCard grid={item} options={grid.options} isLoading={isLoading} />;
    };

    return (
        <>
            <div
                className="grid gap-[2px] p-[2px] h-full w-full overflow-hidden"
                style={{
                    gridTemplateColumns: `repeat(${grid.gridSize.cols}, minmax(0, 1fr))`,
                }}
            >
                {grid.gridData.map((item) =>
                    // <GridwallCard key={index} grid={item} options={grid.options} isLoading={isLoading} />
                    renderGridItem(item)
                )}
            </div>
        </>
    );
};

export default GridwallGrid;
